export default __webpack_public_path__ + "static/media/timeline-1.26781b45.jpg";